export default {
    1: {
        id: 1,
        text: 'Pendiente',
        type: 'warning'
    },
    2: {
        id: 2,
        text: 'Exitoso',
        type: 'success'
    },

    3: {
        id: 3,
        text: 'Cancelado',
        type: 'danger'
    },
    4: {
        id: 4,
        text: 'Anulado',
        type: 'warning'
    },
};
